// removed by extract-text-webpack-plugin
module.exports = {"header":"Construct_header--1K4I3","main":"Construct_main--1q5XC","footer":"Construct_footer--i_laI","base":"Construct_base--2Q8RI","holder":"Construct_holder--3knpG","titleWrapper":"Construct_titleWrapper--9rkL-","back":"Construct_back--25JPI","warning":"Construct_warning--a7EO-","title":"Construct_title--3pFym","cost":"Construct_cost--1zsro"};


//////////////////
// WEBPACK FOOTER
// ./containers/Construct/Construct.scss
// module id = 2165
// module chunks = 11